import { create } from 'zustand';
import { PricingContext, ZERO_PRICING } from './pricing';

export interface SimulatedReseller {
  id: string;
  name: string;
  discount_percent: number;
  margin_percent: number;
  brand_color: string | null;
}

interface PricingState {
  simulatedReseller: SimulatedReseller | null;
  setSimulatedReseller: (reseller: SimulatedReseller | null) => void;
}

export const usePricingStore = create<PricingState>((set) => ({
  simulatedReseller: null,
  setSimulatedReseller: (reseller) => set({ simulatedReseller: reseller }),
}));

export function resolvePricingContext(
  role: 'admin' | 'reseller' | null,
  reseller: { discount_percent: number; margin_percent: number } | null,
  simulatedReseller: SimulatedReseller | null,
  domainReseller?: { discount_percent: number; margin_percent: number } | null
): PricingContext | null {
  if (role === 'admin') {
    if (simulatedReseller) {
      return {
        discountPercent: simulatedReseller.discount_percent,
        marginPercent: simulatedReseller.margin_percent,
      };
    }
    return ZERO_PRICING;
  }

  if (role === 'reseller' && reseller) {
    return {
      discountPercent: reseller.discount_percent,
      marginPercent: reseller.margin_percent,
    };
  }

  if (domainReseller) {
    return {
      discountPercent: domainReseller.discount_percent,
      marginPercent: domainReseller.margin_percent,
    };
  }

  return null;
}
